module.exports = __webpack_public_path__ + "img/video.4e0e3f33.svg";